<template>
    <div class="block quote-block">
        <div class="relative-box">
            <span class="decoration">
                <svg width="36px" height="30px" viewBox="0 0 36 30">
                    <path fill-rule="evenodd"  fill="rgb(255, 43, 43)"
                    d="M0.004,30.010 L14.248,30.010 L14.248,15.986 L7.507,15.986 C7.507,12.260 7.941,9.523 8.813,7.770 C9.681,6.017 11.348,5.068 13.813,4.921 L12.075,-0.009 C7.723,0.064 4.679,1.618 2.941,4.648 C1.200,7.679 0.257,12.336 0.112,18.615 C0.040,20.954 0.004,24.751 0.004,30.010 L0.004,30.010 ZM20.773,30.010 L35.018,30.010 L35.018,15.986 L28.277,15.986 C28.277,12.260 28.710,9.523 29.578,7.770 C30.450,6.017 32.118,5.068 34.582,4.921 L32.843,-0.009 C28.493,0.064 25.447,1.618 23.709,4.648 C21.969,7.679 21.027,12.336 20.880,18.615 C20.809,20.954 20.773,24.751 20.773,30.010 L20.773,30.010 Z"/>
                </svg>
            </span>
            <blockquote>
                <p v-html="layout.caption"></p>
                <footer>
                    <cite>{{layout.cite}}</cite>
                </footer>
            </blockquote>
        </div>
        <div class="decoration-grid" v-if="layout.decoration"></div>
    </div>
</template>

<script>
export default {
    props: {
        layout: {
            type: Object,
            default() {}
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.quote-block
    display: flex
    flex-direction: column
    position: relative
    padding-top: 10%
    padding-bottom: 10%
    overflow: hidden
    @media print
        padding-top: 1.2cm
        padding-bottom: 1.2cm
        page-break-inside: avoid
        break-inside: avoid
    .relative-box
        max-width: 1190px
        margin: auto
    .decoration
        position: absolute
        top: 0px
        left: 0px
        svg
            @include media-breakpoint-down($sm)
                width: 20px

    blockquote
        padding-left: 150 / 1220 * 100%
    cite
        font-size: 28px
        font-weight: 500
        margin-top: 6.4%
        display: block
        @media print
            margin-top: .6cm
    /deep/ p
        font-size: 86px
        color: #ff2b2a
        margin: 0
        line-height: 1.0465116279
        letter-spacing: -0.05813953488em
        font-weight: 500
        @include media-breakpoint-down($hd)
            font-size: 50px
        @include media-breakpoint-down($sm)
            font-size: 36px
.decoration-grid
    position: absolute
    left: 0
    top: 0
    width: auto
    right: 0
    height: 100%
    z-index: -1
    background-image: url('./../../assets/cross-red-fade.svg')
    background-position: 0 0
    background-size: 45px 45px
    margin-left: -20%
    margin-right: -20%
    @include media-breakpoint-up($xxl)
        padding-left: 9.6%
        width: auto
        padding-right: 9.6%
        margin: 0
        overflow: hidden
    @media print
        display: none
</style>
